import { PRReturnPolozky } from './polozky';

export { DMS_MODULE, MODULE_API } from '../constants';
export const NAME = 'PRReturn';
export const NAMEPolozky = 'PRReturnPolozky';
export const CRUMB_LABEL_KEY = 'edtPRReturn';
export const CRUMB_LABEL_LIST = 'grdPRReturn';
export const PRReturnAttachmentFiles = 'PRReturnAttachmentFiles';

export const DOKLADY = <const>'Doklady';
export const EDL = 'Edl';

export enum NDPRIJEMKA_STATUS {
	OTEVRENA = 0,
	UZAV_KE_KOREKCI = 1,
	UZAVRENA = 2,
	VYRAZENA = 3,
	ERROR = 99,
}
export enum PR_RETURN_STATUS {
	CLOSED = 'CLOSED',
	OPEN = 'OPEN'
}


export const DEPENDENT_TABLES = <const>[
	PRReturnPolozky.name,
	PRReturnAttachmentFiles,
];

export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export enum TAB_NAMES {
	HLAVNI = 'Hlavni',
	ATTACHMENT = 'Attachment',
}

export const TABS = {
	[TAB_NAMES.HLAVNI]: { id: TAB_NAMES.HLAVNI, labelKey: 'tsPROrders' },
	[TAB_NAMES.ATTACHMENT]: { id: TAB_NAMES.ATTACHMENT, labelKey: 'Attachment' },
};

export const ND_NR = 'ND_NR';

export const GRID_COLUMNS = {
	ND_NR,
};
